//new
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    region: "us-west-1",
    folderName: "audios"
};